/* js/change-language.js */

;(function($, window, document) {
       
    $("#toggle-change-languages").on('click', function(event) {
      event.preventDefault();
      $(this).toggleClass("on");
      $(".level_1").toggleClass("open");
    });
    
})(jQuery, window, document);